(function (angular) {
    'use strict';

    angular.module('app')
        .controller('promotionController', promotionController);

    promotionController.$inject = [
        '$rootScope',
        'promotionPayload',
        'PromotionsTellMeMoreApi',
        'alerts',
    ];

    function promotionController(
        $rootScope,
        promotionPayload,
        PromotionsTellMeMoreApi,
        alerts
    ) {
        var vm = this;

        // properties
        vm.thisUser = $rootScope.thisUser;
        vm.promotion = promotionPayload;

        // methods
        vm.tellMeMore = tellMeMore;
        vm.startDateFormatted = window.moment.tz(vm.promotion.starts_at, 'UTC').tz('Europe/London').format('ddd Do MMM YYYY hh:mma');
        vm.endDateFormatted = vm.promotion.ends_at ? window.moment.tz(vm.promotion.ends_at, 'UTC').tz('Europe/London').format('ddd Do MMM YYYY hh:mma') : '';

        function tellMeMore() {
            PromotionsTellMeMoreApi.post({
                id: vm.promotion.id,
            }, function handleTellMeMoreResponse() {
                vm.promotion.told = true;
                alerts.emit({
                    theme: 'success',
                    title: 'Offer Claimed',
                    messages: ['A message has been sent to the owner of this offer. Someone will be in touch shortly to assist you with the redemption of this offer.']
                    });
            }, function handleTellMeMoreError () {
                vm.promotion.told = false;

                alerts.emit({
                    theme: 'error',
                    title: 'There was an issue claiming your promotion, please try again',
                });
            });
        }
    }

}(angular));